<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ search }}<br /><br />
    {{ item }} -->
    <b-card class="standardpage reports invoices border-none">
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.eventcode }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Event Code" label-for="eventcode" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.eventcode" @ placeholder="Enter event code" size="sm"
                          trim ></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.eventcode = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Event Name" label-for="eventname" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.eventname" placeholder="Enter event name"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.eventdescription = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Event Date" label-for="eventdate" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.dateevent" button-only label-help=""
                            locale="en-GB"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.dateevent" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.dateevent = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Event End" label-for="dateend" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.dateend" button-only label-help=""
                            locale="en-GB"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.dateend" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.dateend = null">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Comments" label-for="comments" label-cols="12">
                      <b-form-textarea id="data" v-model="item.comments" placeholder="Comments" rows="6" max-rows="8"
                        class="smalltextarea"></b-form-textarea>
                    </b-form-group> </b-col></b-row>
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Budget Code')
                      " :class="$helpers
                        .requiredlabel(requirement, 'Budget Code')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <!-- <b-form-group label="Accounting Code" label-for="accountingcode" label-cols="12"> -->
                      <treeselect instanceId="budgetcode" type="number" v-model="item.budgetcode" :clearable="true"
                        :options="budgetcode_options"></treeselect>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'VAT Region')
                      " :class="$helpers
                        .requiredlabel(requirement, 'VAT Region')
                        .slice(0, 1) == '*'
                        ? 'text-danger'
                        : ''
                        " label-size="sm">
                      <!-- <b-form-group label="VAT Region" label-for="vatregion" label-cols="12" size="sm"> -->
                      <treeselect instanceId="vatregion" type="number" v-model="item.vatregion" :clearable="true"
                        @input="v => value = v || ''" :options="vatregion_options"></treeselect>
                    </b-form-group>
                  </b-col>

                  <!-- 
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Sales Group" label-for="salesgroup" label-cols="12" size="sm">
                      <treeselect instanceId="salesgroup" type="number" v-model="item.salesgroup" :clearable="true"
                        @input="v => value = v || ''" :options="salesgroups_options"></treeselect>
                    </b-form-group>
                  </b-col> -->

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Invoice" label-for="oninvoice" label-cols="12">
                      <b-form-radio-group id="oninvoice" v-model="item.oninvoice" :options="[
                        { text: 'Show', value: true },
                        { text: 'Hide', value: false },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Closed?" label-for="closed" label-cols="12">
                      <b-form-radio-group id="closed" v-model="item.closed" :options="[
                        { text: 'Yes', value: true },
                        { text: 'No', value: false },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Time Zone" label-for="timezone" label-cols="12" size="sm">
                      <treeselect instanceId="timezone" type="number" v-model="item.timezone" :clearable="true"
                        @input="v => value = v || ''" :options="timezone_options"></treeselect>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help=""
                            locale="en-GB" :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit"
                v-if="user.permissions.includes('setup_events.admin')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="auto">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "EventEdit",

  data() {
    return {
      busy: false,
      requirement: {
        vatregion: "VAT Region",
        budgetcode: "Budget Code"
      },
      postit_disabled: false,
      item: {
        dateevent: this.$moment().format("YYYY-MM-DD"),
        dateend: this.$moment().format("YYYY-MM-DD"),
        timezone: null,
        eventcode: null,
        eventname: null,
        salesgroup: "F1",
        vatregion: null,
        budgetcode: null,
        closed: false,
        oninvoice: true,
      },
      vatregion_options: [
        { id: "EEC", label: "EEC" },
        { id: "NEEC", label: "NEEC" },
        { id: "UK", label: "UK" },
      ],
      salesgroups_options: [],
      timezone_options: [],
      budgetcode_options: [],
      options: {
        title: "Event",
        icon: "fa fa-calendar-check-o",
      },
    };
  },
  watch: {
    "item.budgetcode": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.budgetcode = ""
        }
      }
    },
    "item.salesgroup": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.salesgroup = ""
        }
      }
    },
    "item.vatregion": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.vatregion = ""
        }
      }
    },
    "item.timezone": {
      async handler(newVal, oldVal) {
        if (typeof newVal === "undefined") {
          this.item.timezone = ""
        }
      }
    },
  },
  methods: {
    async loadDDL() {
      this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_budgets {
              setup_budgets {
                id
                description
                label
              }
            }
          `,
        });
        this.budgetcode_options = response.data.setup_budgets.concat([{ id: "", label: "" }]);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query salesgroups {
              salesgroups(isenabled: true) {
                id
                label: id
              }
            }
          `,
        });
        this.salesgroups_options = response.data.salesgroups.concat([{ id: "", label: "" }]);
      } catch (error) {
        console.log(error);
      }

      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_timezones {
              setup_timezones {
                id
                label
              }
            }
          `,
        });
        this.timezone_options = response.data.setup_timezones.concat([{ id: "", label: "" }]);
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query events($id: String, $dateformat: String) {
              events(id: $id, dateformat: $dateformat) {
                id
                eventcode
                eventname
                dateevent
                comments
                salesgroup
                vatregion
                budgetcode
                closed
                oninvoice
                dateend
                timezone
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.events.length > 0) {
          this.item = response.data.events[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      let row = this.cleanit(this.item);

      if (row.dateevent) {
        if (parseInt(this.$moment(row.dateevent).format("YYYY")) < parseInt(this.$moment().format("YYYY"))) {
          this.message = "<span class='text-danger'>Event Date must be equal to or greater than the current year.</span>";
          return;
        }
      }

      if (row.dateevent && row.dateend) {
        if (this.$moment(row.dateevent).diff(this.$moment(row.dateend), "days")  > 0) {
          this.message = "<span class='text-danger'>Event End Date must be equal to or greater than the Event Date.</span>";
          return;
        }
      }

      this.message = this.$helpers.mandatoryFields(
        {
          vatregion: "VAT Region",
          budgetcode: "Accounting Code"
        },
        row
      );

      if (this.message.length > 0) {
        return;
      }
      this.busy = true;

      let variables = { rows: [row] };
      if (this.config.action == 'copy') {
        variables.rows[0].id = null
      }
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation saveevents($rows: [Event_input], $dateformat: String) {
              saveevents(rows: $rows, dateformat: $dateformat) {
                id
                eventcode
                eventname
                dateevent
                comments
                salesgroup
                vatregion
                budgetcode
                closed
                oninvoice
                timezone
                dateend
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>